/**
 * Learn more about theme events at
 * https://help.switchthemes.co/shapes/developer/theme-events/overview.html
 */

window.theme = window.theme || {};

window.theme.events = {
  version: '1.0',
  listeners: [], // Track all event listeners for cleanup
  
  // Helper to add tracked event listeners
  addEventListener: function(element, event, handler, options) {
    element.addEventListener(event, handler, options);
    this.listeners.push({ element, event, handler, options });
  },
  
  // Cleanup all event listeners
  cleanup: function() {
    this.listeners.forEach(({ element, event, handler, options }) => {
      element.removeEventListener(event, handler, options);
    });
    this.listeners = [];
  }
};

// Store handler references for cleanup
const updateCartHandler = async () => {
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    if (!data.status) {
      document.dispatchEvent(
        new CustomEvent('shapes:cart:update', {
          bubbles: true,
          detail: {
            response: {
              sections: {
                ...data,
              },
            },
          },
        })
      );
    }
  } catch (e) {
    console.error(e);
    document.getElementById('cart-errors').textContent =
      theme.strings.cartError;
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: theme.strings.cartError,
          error: e,
        },
      })
    );
  } finally {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }
};

window.theme.events.addEventListener(document, 'theme:update:cart', updateCartHandler);

const getCartDrawerEl = () => {
  return document.querySelector('[data-cart-drawer]');
};

const cartWillOpenHandler = async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:opening', {
      detail,
    })
  );
};
window.theme.events.addEventListener(document, 'cart-will-open', cartWillOpenHandler);

const cartIsOpenHandler = async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      detail,
    })
  );
};
window.theme.events.addEventListener(document, 'cart-is-open', cartIsOpenHandler);

const cartWillCloseHandler = () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closing', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
};
window.theme.events.addEventListener(document, 'cart-will-close', cartWillCloseHandler);

const cartIsClosedHandler = () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closed', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
};
window.theme.events.addEventListener(document, 'cart-is-closed', cartIsClosedHandler);

const openCartDrawerHandler = () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').closeAll();

    Alpine.store('modals').open('cart');
  }
};
window.theme.events.addEventListener(document, 'theme:open:cart-drawer', openCartDrawerHandler);

const closeCartDrawerHandler = () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').close('cart');
  }
};
window.theme.events.addEventListener(document, 'theme:close:cart-drawer', closeCartDrawerHandler);

const cartChangeEventHandler = (e) => {
  const { cartItemCount, itemsRootEl, lineItemEl, variantId, key } = e.detail;

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        type: e.type,
        cartItemCount,
        itemsRootEl,
        lineItemEl,
        variantId,
        key,
        originalDetail: e.detail,
      },
    })
  );
};

window.theme.events.addEventListener(document, 'theme:product:add', cartChangeEventHandler);
window.theme.events.addEventListener(document, 'theme:line-item:change', cartChangeEventHandler);

const cartErrorEventHandler = (e) => {
  document.dispatchEvent(
    new CustomEvent('theme:cart:error', {
      detail: {
        type: e.type,
        message: e.detail.message,
        originalDetail: e.detail,
      },
    })
  );
};

window.theme.events.addEventListener(document, 'theme:product:error:add-to-cart', cartErrorEventHandler);
window.theme.events.addEventListener(document, 'theme:line-item:error', cartErrorEventHandler);
window.theme.events.addEventListener(document, 'theme:cart:error:other', cartErrorEventHandler);

/**
 * Set `window.themeEventsDebugMode` to `true` to log events
 * outside the theme editor
 */

if (Shopify.designMode || window.themeEventsDebugMode) {
  const themeEvents = [
    'theme:variant:change',
    'theme:product:add',
    'theme:line-item:change',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart-drawer:opening',
    'theme:cart-drawer:open',
    'theme:cart-drawer:closing',
    'theme:cart-drawer:closed',
    'theme:product:error:add-to-cart',
    'theme:line-item:error',
    'theme:cart:error:other',
    'theme:cart:error',
  ];

  const aggregateEvents = ['theme:cart:change', 'theme:cart:error'];

  for (const eventName of themeEvents) {
    let color;

    if (eventName.includes('error')) {
      color = '#ef4444';
    } else {
      color = '#22c55e';
    }

    const message = [
      `%c\u25CF %c${eventName}`,
      `color: ${color};`,
      'font-weight: bold;',
    ];

    if (aggregateEvents.includes(eventName)) {
      const debugHandler = (e) => {
        console.groupCollapsed(...message);
        console.log(
          `Underlying event: %c${e.detail.type}`,
          'font-weight: bold;'
        );
        console.log('Event detail:', e.detail);
        console.groupEnd();
      };
      window.theme.events.addEventListener(document, eventName, debugHandler);
    } else {
      const debugHandler = (e) => {
        console.log(...message, e.detail);
      };
      window.theme.events.addEventListener(document, eventName, debugHandler);
    }
  }
}

// Cleanup all event listeners on page unload
window.addEventListener('beforeunload', () => {
  window.theme.events.cleanup();
});